import { render, staticRenderFns } from "./EmployeeVacationsWidget.vue?vue&type=template&id=2e2f0d98&scoped=true&"
import script from "./EmployeeVacationsWidget.vue?vue&type=script&lang=js&"
export * from "./EmployeeVacationsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2f0d98",
  null
  
)

export default component.exports